/* Capiaghi Summer V2 — behaviour. No framework, no dependencies. */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;

  /* ---------------------------------------------------------- helpers */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var f = window.CS && window.CS.moneyFormat ? window.CS.moneyFormat : '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, amt).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function lock(on) { body.classList.toggle('no-scroll', !!on); }

  /* --------------------------------------------------- overlays/drawers */
  function bindToggle(triggerSel, targetSel, scrimSel) {
    var target = $(targetSel);
    if (!target) return;
    var scrim = scrimSel ? $(scrimSel) : null;

    function open() {
      target.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      target.setAttribute('aria-hidden', 'false');
      lock(true);
      var f = target.querySelector('input,button,a');
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
    function close() {
      target.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      target.setAttribute('aria-hidden', 'true');
      lock(false);
    }

    $$(triggerSel).forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $$('[data-close]', target).forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && target.classList.contains('is-open')) close();
    });
    target._open = open;
    target._close = close;
  }

  bindToggle('[data-open-search]', '#search-overlay');
  bindToggle('[data-open-menu]', '#mobile-nav');
  bindToggle('[data-open-cart]', '#cart-drawer', '#cart-scrim');
  bindToggle('[data-open-filters]', '#filter-sheet');
  bindToggle('[data-open-sizeguide]', '#size-guide', '#size-guide-scrim');

  /* Keyboard: "/" opens search */
  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
      var s = $('#search-overlay');
      if (s && s._open) { e.preventDefault(); s._open(); }
    }
  });

  /* ------------------------------------------------ header on scroll */
  var header = $('[data-header]');
  if (header && header.classList.contains('header--over')) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.72);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --------------------------------------------- predictive search */
  var sInput = $('[data-search-input]');
  var sResults = $('[data-search-results]');
  var sEmpty = $('[data-search-empty]');
  if (sInput && sResults) {
    var timer, lastQ = '';
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(timer);
      if (q.length < 1) {
        sResults.innerHTML = '';
        if (sEmpty) sEmpty.classList.remove('js-hidden');
        lastQ = '';
        return;
      }
      if (sEmpty) sEmpty.classList.add('js-hidden');
      timer = setTimeout(function () {
        if (q === lastQ) return;
        lastQ = q;
        var url = '/search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6' +
          '&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-search-results]');
            sResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { /* stay silent; the form still submits */ });
      }, 180);
    });
  }

  /* --------------------------------------------------- accordions */
  $$('[data-acc]').forEach(function (acc) {
    var btn = $('.acc__btn', acc);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = acc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Footer accordions, mobile only */
  $$('[data-accordion]').forEach(function (col) {
    var h = $('h3', col);
    if (!h) return;
    h.addEventListener('click', function () {
      if (window.matchMedia('(max-width:760px)').matches) col.classList.toggle('is-open');
    });
  });

  /* -------------------------------------------- variant selection */
  $$('[data-product-form]').forEach(function (form) {
    var data = $('[data-variants]', form);
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]', form);
    var submit = $('[data-submit]', form);
    /* notify-me sits outside the product form (nested forms are invalid) */
    var notify = $('[data-notify]');
    var notifyTags = $('[data-notify-tags]');
    var notifyVariant = $('[data-notify-variant]');

    /* Shopify's customer form drops unknown fields, so the product and size
       ride along as tags. Rebuild them whenever the size changes. */
    function handleize(str) {
      return String(str).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    var chosen = {};

    $$('[data-option]', form).forEach(function (btn) {
      if (btn.getAttribute('aria-pressed') === 'true') {
        chosen[btn.dataset.optionIndex] = btn.dataset.optionValue;
      }
      btn.addEventListener('click', function () {
        var idx = btn.dataset.optionIndex;
        chosen[idx] = btn.dataset.optionValue;
        $$('[data-option][data-option-index="' + idx + '"]', form).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        update();
      });
    });

    function update() {
      var match = variants.find(function (v) {
        return Object.keys(chosen).every(function (i) {
          return v.options[Number(i)] === chosen[i];
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);

      var available = match.available;
      if (submit) submit.classList.toggle('js-hidden', !available);
      if (notify) notify.classList.toggle('js-hidden', available);

      if (notifyTags) {
        var h = notifyTags.dataset.notifyHandle;
        var tags = ['back-in-stock', 'bis-' + h];
        if (match.title && match.title !== 'Default Title') {
          tags.push('bis-' + h + '-' + handleize(match.title));
        }
        notifyTags.value = tags.join(', ');
      }

      /* Klaviyo subscribes against the variant, so this has to track the
         chosen size exactly. A stale id would email the wrong restock. */
      if (notifyVariant) notifyVariant.value = match.id;

      /* Changing size means a different subscription, so let them ask again. */
      var nRoot = $('[data-notify-root]');
      if (nRoot && nRoot.classList.contains('is-done')) {
        nRoot.classList.remove('is-done');
        var st = $('[data-notify-status]', nRoot);
        if (st) st.textContent = '';
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
    update();
  });

  /* ------------------------------------- back in stock, via Klaviyo */
  /* Posts the signup straight to Klaviyo against the selected variant, so
     Klaviyo can watch inventory and email that person when their size
     lands. Anything less than a clean 202 falls through to the native
     Shopify form, which records the tags — a signup is never dropped. */
  (function () {
    var nRoot = $('[data-notify-root]');
    if (!nRoot) return;

    var kForm = nRoot.querySelector('form');
    var kKey = (nRoot.getAttribute('data-klaviyo-key') || '').trim();
    var kStatus = $('[data-notify-status]', nRoot);
    if (!kForm || !kKey || !window.fetch) return;

    kForm.addEventListener('submit', function (e) {
      var vField = $('[data-notify-variant]', nRoot);
      var emailField = kForm.querySelector('input[type="email"]');
      var vid = vField ? String(vField.value).trim() : '';
      var email = emailField ? emailField.value.trim() : '';

      /* No variant or no email — let Shopify handle it, including validation. */
      if (!vid || !email) return;

      e.preventDefault();
      var btn = kForm.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      if (kStatus) kStatus.textContent = 'One moment…';

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(kKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.status === 202) {
            nRoot.classList.add('is-done');
            if (kStatus) kStatus.textContent = 'Noted. We’ll email you the moment it lands.';
            if (btn) btn.disabled = false;
          } else {
            /* Bad key, unknown variant, rate limit — don't lose the signup. */
            kForm.submit();
          }
        })
        .catch(function () { kForm.submit(); });
    });
  })();

  /* ------------------------------------------------- add to cart */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = $('[data-submit]', form);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding'; btn.disabled = true; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () {
          var d = $('#cart-drawer');
          if (d && d._open) d._open();
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.textContent = label; btn.disabled = false; } });
    });
  });

  function refreshCart() {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var live = $('[data-cart-inner]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (el) {
          if (count) el.textContent = count.textContent;
        });
      });
  }

  /* Delegated, so it survives every drawer re-render without re-binding. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
      }).then(refreshCart);
      return;
    }

    var add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var label = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.quickAdd), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(refreshCart)
        .catch(function () { add.textContent = label; add.disabled = false; });
    }
  });

  /* ------------------------------------------- sticky buy (mobile) */
  var sticky = $('[data-sticky-buy]');
  var gallery = $('[data-gallery]');
  if (sticky && gallery && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(gallery);
  }

  /* ---------------------------------------------- recently viewed */
  try {
    var pid = root.getAttribute('data-product-id');
    var KEY = 'cs_recent';
    var seen = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (pid) {
      seen = [pid].concat(seen.filter(function (x) { return x !== pid; })).slice(0, 8);
      localStorage.setItem(KEY, JSON.stringify(seen));
    }
  } catch (e) { /* private mode — skip silently */ }
})();
